module.exports = __webpack_public_path__ + "img/1.ef7d35bb.jpg";